// @ts-strict-ignore
import { QuickStartCIFile } from './../../../types';
import { selectAuthCredentials } from '../../../selectors/selectors';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers/reducers';
import { useState } from 'react';
import { withAuthorizationHeaders } from '../../../api';
import { fileNameForFileType } from '../../../helpers/displayHelpers';

export type DownloadFilesHookData = [boolean, Error, (files: QuickStartCIFile[]) => Promise<void>];

export const useDownloadFiles: () => DownloadFilesHookData = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const startDownload = async (files: QuickStartCIFile[]) => {
        setIsLoading(true);
        setError(undefined);
        try {
            const headers = withAuthorizationHeaders(authCredentials);
            for (const file of files) {
                const urlResponse = await fetch(file.fileUrl, {
                    method: 'GET',
                    headers: headers,
                });

                const response = await fetch(urlResponse.url, {
                    method: 'GET',
                });

                if (!response.ok) {
                    throw new Error(`Failed to download file: ${response.statusText}`);
                }

                const blob = await response.blob();

                if (!blob) {
                    throw new Error('Failed to download file: No data received');
                }

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileNameForFileType(file.fileType);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return [isLoading, error, startDownload];
};
